import { ref } from "vue"
import { KNOLIA } from "@/knolia"
import { Gems } from "@/gems"
import { MESSAGES } from "@/messages"

export function useUploadDocs() {
  const allowedExtensions = 'Extensões permitidas: csv, xls, xlsx, png, jpg, jpeg, gif, txt, pdf, docx, doc, zip'
  const newFileName = ref('')

  async function DownloadFile(file) {
    await KNOLIA.CallBackEnd("get", "download-file", {
      responseType: "blob",
      params: { stored_name: file.stored_name, file_designation: file.designation, uploaded_by: file.uploaded_by },
    }).then(async (res) => {
      if(!res)
        return
    
      const fileRes = new Blob([res.request.response], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(fileRes);
      const a = document.createElement("a");
      a.className = "hidden";
      a.href = url;
      a.download = file.designation
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      Gems.Telegram(MESSAGES.INFO.BROWSER_WARNING, "tele-success")
    });
  }

  function PermittedExtensions(fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    const permittedExtensions = ['csv', 'xls', 'xlsx', 'png', 'jpg', 'jpeg', 'gif', 'txt', 'pdf', 'docx', 'doc', 'zip'];
    return permittedExtensions.includes(extension);
  }

  async function Upload(uploadedAttachments, files, callbackFn, isCv = false) {
    const formData = new FormData();
    for (let file in files) {
      if(typeof files[file] != 'object')
        continue

      if (!PermittedExtensions(files[file].name)) {
        Gems.Telegram(MESSAGES.ERROR.INVALID_FILE, "tele-not-allowed")
        return
      }

      if (files[file].size > 10485760) {
        Gems.Telegram(MESSAGES.ERROR.FILE_SIZE, "tele-not-allowed")
        return
      }

      if(uploadedAttachments.find(att => att.designation === files[file].name)) {
        Gems.Telegram(MESSAGES.ERROR.FILE_ALREADY_EXISTS, "tele-not-allowed")
        return
      }

      formData.append(file, files[file])
    }

    formData.append('is_cv', isCv)

    KNOLIA.CallBackEnd("post", "upload-files", formData).then(async (res) => {
      if (res.data.error) {
        Gems.Telegram(MESSAGES.ERROR[`${res.data.message}`], "tele-not-allowed")
      } else {
        callbackFn()
      }
    });
  }

  async function RemoveFile(file, callbackFn) {
    await KNOLIA.CallBackEnd("post", "set-operations&get=remove-file", {
      file: file,
    }).then(() => {
      callbackFn()
    });
  }

  async function RenameFile(uploadedAttachments, file, callbackFn) {
    file.rename = !file.rename

    if(file.rename) {
      newFileName.value = file.designation.slice(0, file.designation.lastIndexOf('.'))
    } else {
      if(uploadedAttachments.find(att => att.designation === newFileName.value + '.' + file.file_extension)) {
        Gems.Telegram(MESSAGES.ERROR.FILE_ALREADY_EXISTS, "tele-not-allowed")
        return
      }

      file.designation = newFileName.value + '.' + file.file_extension

      KNOLIA.CallBackEnd("post", "set-operations&get=rename-file", {file})
        .then((res) => {
          if (res.error)
            Gems.Telegram(MESSAGES.ERROR.DEFAULT, "tele-not-allowed")

          if(res.data.error)
            Gems.Telegram(MESSAGES.ERROR[`${res.data.message}`], "tele-not-allowed")

          callbackFn()
        });
    }
  }

  async function SetVisibilityFile(attachment) {
    await KNOLIA.CallBackEnd("post", "set-operations&get=file-visibility", {
      params: {
        file_id: attachment.id,
        is_public: attachment.is_public
      },
    }).then((res) => {
      if (res.data.error)
        Gems.Telegram(MESSAGES.ERROR[`${res.data.message}`], "tele-not-allowed")
    })
  }

  async function AssociateFileToRatingSkill(attachmentId, elem, associationId, callbackFn) {
    await KNOLIA.CallBackEnd("post", "set-operations&get=associate-file-to-rating-skill", {
      params: {
        file_id: attachmentId,
        elem: elem,
        association_id: associationId
      },
    }).then((res) => {
      if (res.data.error)
        Gems.Telegram(MESSAGES.ERROR[`${res.data.message}`], "tele-not-allowed")

      callbackFn(res.data.skills_ratings_id)
    })
  }

  return {
    allowedExtensions,
    newFileName,
    DownloadFile,
    Upload,
    RemoveFile,
    RenameFile,
    SetVisibilityFile,
    AssociateFileToRatingSkill,
  }
}